import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home/index.vue'
import detail from '../views/detail/index.vue'
import magazine from '../views/magazine/index.vue'
import search from '../views/search/index.vue'
import channel from '../views/channel/index.vue'
import NotFound from '../views/NotFound.vue'
import SpecialMobilePage from '../views/specialMobile/index.vue'

// 手机端页面 - 懒加载
const MobileLogin = () => import('../views/mobile/Login.vue')
const MobileMy = () => import('../views/mobile/My.vue')
const MobileArticles = () => import('../views/mobile/Articles.vue')
const MobilePersonalInfo = () => import('../views/mobile/PersonalInfo.vue')
const MobileCompanyInfo = () => import('../views/mobile/CompanyInfo.vue')
const MobilePublishArticle = () => import('../views/mobile/PublishArticle.vue')
const MobileMagazine = () => import('../views/mobile/Magazine.vue')
const MobileOrders = () => import('../views/mobile/Orders.vue')

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail
  },
  {
    path: '/magazine',
    name: 'magazine',
    component: magazine
  },
  {
    path: '/search',
    name: 'search',
    component: search
  },
  {
    path: '/channel/index',
    name: 'channel-query',
    component: channel
  },
  {
    path: '/channel/:categoryId',
    name: 'channel',
    component: channel
  },
  // ========== 手机端路由 ==========
  {
    path: '/login',
    name: 'mobile-login',
    component: MobileLogin,
    meta: { title: '登录注册' }
  },
  {
    path: '/my',
    name: 'mobile-my',
    component: MobileMy,
    meta: { title: '个人中心', requiresAuth: true }
  },
  {
    path: '/my/articles/:tab',
    name: 'mobile-articles',
    component: MobileArticles,
    props: true,
    meta: { title: '我的文章', requiresAuth: true }
  },
  {
    path: '/my/publish',
    name: 'mobile-publish',
    component: MobilePublishArticle,
    meta: { title: '发布文章', requiresAuth: true }
  },
  {
    path: '/my/magazine',
    name: 'mobile-magazine',
    component: MobileMagazine,
    meta: { title: '我的电子杂志', requiresAuth: true }
  },
  {
    path: '/my/orders',
    name: 'mobile-orders',
    component: MobileOrders,
    meta: { title: '我的订单', requiresAuth: true }
  },
  {
    path: '/my/personal',
    name: 'mobile-personal',
    component: MobilePersonalInfo,
    meta: { title: '个人资料', requiresAuth: true }
  },
  {
    path: '/my/company',
    name: 'mobile-company',
    component: MobileCompanyInfo,
    meta: { title: '企业信息', requiresAuth: true }
  },
  {
    path: '/special',
    name: 'special-mobile',
    component: SpecialMobilePage,
    meta: { title: '专题' }
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 登录守卫与页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  // 需要登录的页面
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

export default router
